import Blank from './Blank.svg';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { CardMedia } from '@mui/material';
import React from 'react';
import * as Styled from './TemplateCard.styles';
import MenuListButton from '../MenuListButton';
import { Svg } from '../Svg';
const TemplateCard = ({ title, description, id, owner, image, dataCy, isDeleting = false, deleteTemplateText, editTemplateText, onDeleteClick, onEditClick, onCardClick, }) => {
    const isDeleteEnabled = !!onDeleteClick && !!deleteTemplateText;
    const isEditEnabled = !!onEditClick && !!editTemplateText;
    const isMenuEnabled = isDeleteEnabled || isEditEnabled;
    const menuItems = [];
    if (isEditEnabled) {
        menuItems.push({
            text: editTemplateText,
            icon: React.createElement(EditIcon, { fontSize: "small" }),
            onClick: onEditClick,
            cy: 'editOption',
        });
    }
    if (isDeleteEnabled) {
        menuItems.push({
            text: deleteTemplateText,
            icon: React.createElement(DeleteIcon, { fontSize: "small" }),
            onClick: onDeleteClick,
            props: { disabled: isDeleting },
            cy: 'deleteOption',
        });
    }
    return (React.createElement(Styled.Card, { id: id, "data-cy": dataCy, onClick: isDeleting ? undefined : onCardClick },
        image ? (React.createElement(CardMedia, { component: "img", alt: `${dataCy}-image`, image: image })) : (React.createElement(Svg, { svg: Blank })),
        React.createElement(Styled.CardHeader, { action: isMenuEnabled && (React.createElement(MenuListButton, { cy: "templateThreeDotMenu", menuItems: menuItems })), title: React.createElement(Styled.TitleText, null, title), subheader: React.createElement(Styled.DescriptionText, null, description) }),
        owner && (React.createElement(Styled.CardActions, null,
            React.createElement(Styled.OwnerText, null, owner)))));
};
export default React.memo(TemplateCard);
